export default {
  main: '#001857',
  secondary: '#FF8A83',
  contrastingColor: '#ffffff',
  priceColor: '#001857',
  entryBackground: '#001857',
  menuBackgroundColor: '#001857',
  menuTextColor: '#ffffff',
};
